var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.69107 0 0 2.6917 0 6C0 9.30893 2.69107 12 6 12C9.30893 12 12 9.30893 12 6C12 2.69107 9.30893 0 6 0ZM6 10.8995C3.2984 10.8995 1.10051 8.7016 1.10051 6C1.10051 3.2984 3.2984 1.10051 6 1.10051C8.7016 1.10051 10.8995 3.2984 10.8995 6C10.8995 8.7016 8.7016 10.8995 6 10.8995ZM6 6.93292C6.18424 6.93292 6.44217 6.80641 6.45753 6.47539L6.61475 3.5933C6.61475 3.25368 6.33901 2.97856 6 2.97856C5.66038 2.97856 5.38525 3.25368 5.38525 3.5933L5.54247 6.47539C5.56028 6.82359 5.79365 6.93292 6 6.93292ZM6 7.45002C5.79243 7.45002 5.58976 7.53477 5.4436 7.68155C5.29743 7.8271 5.21392 8.02976 5.21392 8.2361C5.21392 8.44367 5.29744 8.64634 5.4436 8.79251C5.58976 8.93867 5.79243 9.02218 6 9.02218C6.20757 9.02218 6.41024 8.93928 6.55516 8.79251C6.70255 8.64634 6.78608 8.44306 6.78608 8.2361C6.78608 8.03037 6.70256 7.82709 6.55516 7.68155C6.409 7.53478 6.20757 7.45002 6 7.45002Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.429d44d128bb8219cde5b3b6c924d684.svg";
export { ForwardRef as ReactComponent };